import { memo } from 'react';
import MojitoPresentation from 'mojito/presentation';
import BannerMarket from 'modules/promotions/banners/banner-market/index.js';

const { Image, AbsolutePane, Button } = MojitoPresentation.Components;

const BannerPromotion = memo(function BannerPromotion({
    promotion,
    onClick,
    shouldRequestData,
    mojitoTools: { config },
}) {
    const { event, imgUrl, altText } = promotion;
    const marketId = event && event.market && event.market.marketId;
    const className = `ta-promotion-item`;

    return (
        <Button config={config.container} class={className} onClick={onClick}>
            {imgUrl && (
                <Image
                    config={config.image}
                    src={encodeURI(imgUrl)}
                    class={`ta-img-${imgUrl.replace(/[^A-Za-z0-9-_]/g, '')}`}
                    alt={altText}
                />
            )}
            {marketId && (
                <AbsolutePane config={config.marketOverlay}>
                    <BannerMarket
                        config={config.bannerMarket}
                        event={event}
                        marketId={marketId}
                        shouldRequestData={shouldRequestData}
                    />
                </AbsolutePane>
            )}
        </Button>
    );
});

export default BannerPromotion;
